// @ts-nocheck
/**
 * Generated by orval v7.4.1 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { EvaluationDimensionInputLevel } from './evaluationDimensionInputLevel';
import type { EvaluationDimensionInputComment } from './evaluationDimensionInputComment';

/**
 * Evaluation of a single dimension of a submission
 */
export interface EvaluationDimensionInput {
  /** level of performance */
  level?: EvaluationDimensionInputLevel;
  /** comment on and justification of performance */
  comment?: EvaluationDimensionInputComment;
}
